/**
 * 全局静态属性配置文件
 */
const config = {
	langCode: 'lang', //默认语言接口参数名
	lang: 'zh_CN', //语言值
	isFirst: 'isfirst',
	// apiPath: ,
	// apiPath:"http://124.71.26.85:9151", // 爱儿健开发
	// apiPath:"http://14.29.240.143:9151", // 爱儿健测试
	// apiPath:"http://14.29.212.174:9151", // 爱儿健正式服
	// apiPath:"https://pdm.aico.com.cn/apis", // 爱儿健预上线域名
	// apiPath:"http://47.106.216.107:9151" , //尚捷PDM正式服
	apiPath:"https://api.sjkjgz.com" , //尚捷PDM正式服
	// apiPath:"http://8.134.35.65:9151" , //瑞蒽正式服
	
	// apiPath:window.$store.state.resInfo||"http://api.sjkjgz.com";//测试服务器网关地址
	// baseUrl: 'http://b2b.sjkjgz.com', //二维码生成地址前缀
	// registUrl:'http://regist.sjkjgz.com/',//邀请注册地址
	loginToken: "Basic YXBwOmFwcA==", //登录接口的头部信息
	headerCompanyParam: "user_company", //头部参数
	headerUsernameParam: 'username',
	headerUserIdParam: 'userId',
	Authorization: "Authorization",
	noLoginUrl: "/api/open/",
	loginUrl: "/amc/password/token",
	refreshTokenUrl: "/amc/oauth2/token",
	logoutUrl: "/amc/logout/token",
	phoneLoginUrl: "/amc/phone/token",
	thirdLoginUrl: "/amc/third/token",
	access_token_key: "access_token",
	access_token_exprie_key: "token_access_token_exprie",
	refresh_token_key: "refresh_token",
	corp_id: "dingdb924a38fc73baff35c2f4657eb6378f",
	env: 'aico', //环境 yfg, ds,
	companyName: '爱儿健',
	// minioDomain: 'http://test-mall.eifini.com:9000',
	minioDomain: 'http://10.8.251.6:9000',
}
export default config;